import styles from "@/components/wallpaper-thumbnail.module.css";
import { handleKeyboardClick } from "@/utils";
import { faCircleCheck, faImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { JSX } from "react";

interface WallpaperThumbnailProps {
	description?: string;
	isSelected: boolean;
	onClick: () => void | Promise<void>;
	thumbnail?: string;
}

function WallpaperThumbnail({
	description,
	isSelected,
	onClick,
	thumbnail,
}: WallpaperThumbnailProps): JSX.Element {
	const handleClick = (): void => {
		void onClick();
	};

	return (
		<div
			aria-selected={isSelected}
			className={clsx(
				styles["wallpaper-thumbnail"],
				!thumbnail && styles["disabled"],
			)}
			onClick={handleClick}
			onKeyDown={handleKeyboardClick(handleClick)}
			role="option"
			tabIndex={0}
			title={description}
		>
			{thumbnail ? (
				<>
					<img
						alt={description}
						draggable={false}
						loading="lazy"
						src={thumbnail}
					/>
					{isSelected && (
						<FontAwesomeIcon
							className="fade-in"
							icon={faCircleCheck}
						/>
					)}
				</>
			) : (
				<FontAwesomeIcon icon={faImage} />
			)}
		</div>
	);
}

export default WallpaperThumbnail;
